import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { normalizeTiktokShopTypeSlug } from '@/tiktok-platform/constants/tiktokRoutes';
import TiktokComplianceMaterialsPage from '@/tiktok-platform/modules/compliance/ComplianceMaterialsPage';
import TiktokFullComplianceComingSoon from '@/tiktok-platform/modules/ops/TiktokFullComplianceComingSoon';

/** 全托禁用合规资料（属合规资质）；半托/本土正常进入 */
export function TiktokComplianceMaterialsRoute() {
  const { shopType } = useParams();
  if (normalizeTiktokShopTypeSlug(shopType) === 'full') {
    return <TiktokFullComplianceComingSoon label="合规资质" />;
  }
  return <TiktokComplianceMaterialsPage />;
}

/** 合规根路径进入合规资料；全托禁用 */
export function TiktokComplianceIndexRoute() {
  const { shopType } = useParams();
  if (normalizeTiktokShopTypeSlug(shopType) === 'full') {
    return <TiktokFullComplianceComingSoon label="合规资质" />;
  }
  return <Navigate to="materials" replace />;
}

/** 旧「产品合规」检查页入口：重定向到合规资料 */
export function TiktokProductQualRoute() {
  return <Navigate to="../materials" replace />;
}
